import * as React from "react";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

const defaultMaskOptions = {
    prefix: "",
    suffix: "",
    includeThousandsSeparator: false,
    thousandsSeparatorSymbol: "",
    allowDecimal: true,
    decimalSymbol: ".",
    decimalLimit: 2, // how many digits allowed after the decimal
    allowNegative: false,
    allowLeadingZeroes: false,
    integerLimit: "",
};

export const CurrencyInput = ({ maskOptions, ...inputProps }) => {
    let maxIntergerValue = "";
    let maxDecimalValue = null;
    if (inputProps.max) {
        const maxArr = inputProps.max.toString().split(".");
        if (maxArr.length > 0) {
            maxIntergerValue = maxArr[0].length;
        }
        if (maxArr.length > 1) {
            maxDecimalValue = maxArr[1].length;
        }
    }
    if (maxDecimalValue) {
        defaultMaskOptions.decimalSymbol = ".";
    }
    if (maxIntergerValue) {
        defaultMaskOptions.integerLimit = maxIntergerValue;
    }
    defaultMaskOptions.decimalLimit = maxDecimalValue;
    const currencyMask = createNumberMask({
        ...defaultMaskOptions,
        ...maskOptions,
    });
    inputProps.type = "text";
    return <MaskedInput mask={currencyMask} {...inputProps} />;
};

CurrencyInput.defaultProps = {
    inputMode: "numeric",
    maskOptions: {},
};
